import { useRef } from 'react';
import { FolderOpen, Sparkles, Home } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useViewer } from '@/features/viewer/ViewerContext';
import { useViewerStore } from '@/state/viewerStore';

export function TopBar() {
  const inputRef = useRef<HTMLInputElement>(null);
  const { loadFile, loadSample } = useViewer();
  const modelName = useViewerStore((s) => s.modelName);
  const selection = useViewerStore((s) => s.selection);
  const ready = useViewerStore((s) => s.ready);

  return (
    <header className="pointer-events-none absolute inset-x-0 top-0 z-20 flex items-start justify-between p-3">
      <div className="pointer-events-auto flex items-center gap-3 rounded-lg border border-panel-border bg-panel/85 px-3 py-1.5 backdrop-blur">
        <a href="/" className="flex items-center gap-2 text-sm font-semibold text-foreground" aria-label="IFC Navigator home">
          <svg viewBox="0 0 32 32" width="20" height="20" fill="none" aria-hidden="true">
            <rect width="32" height="32" rx="6" fill="#0e1116" />
            <path d="M8 22 L16 6 L24 22 Z" stroke="#2f81f7" strokeWidth="2" strokeLinejoin="round" />
            <path d="M8 22 L24 22" stroke="#2f81f7" strokeWidth="2" strokeLinecap="round" />
          </svg>
          IFC Navigator
        </a>
        {selection.expressID !== null && (
          <span className="rounded bg-accent/20 px-2 py-0.5 text-xs text-accent">
            #{selection.expressID}
          </span>
        )}
      </div>

      <div className="pointer-events-auto flex items-center gap-2">
        <a
          href="/"
          className="inline-flex h-8 items-center gap-1.5 rounded-md border border-panel-border bg-panel/85 px-3 text-xs text-muted backdrop-blur transition-colors hover:bg-panel hover:text-foreground"
          title="Back to homepage"
        >
          <Home className="h-3.5 w-3.5" />
          Home
        </a>
        <input
          ref={inputRef}
          type="file"
          accept=".ifc"
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) void loadFile(file);
            e.target.value = '';
          }}
        />
        {modelName !== null && (
          <Button variant="outline" onClick={() => void loadSample()} disabled={!ready}>
            <Sparkles className="h-4 w-4" />
            Sample
          </Button>
        )}
        {modelName !== null && (
          <Button onClick={() => inputRef.current?.click()} disabled={!ready}>
            <FolderOpen className="h-4 w-4" />
            Open IFC
          </Button>
        )}
      </div>
    </header>
  );
}
